import { render } from "./ServiceStockTransfer.vue?vue&type=template&id=3dce685b&scoped=true"
import script from "./ServiceStockTransfer.vue?vue&type=script&lang=js"
export * from "./ServiceStockTransfer.vue?vue&type=script&lang=js"

import "./ServiceStockTransfer.vue?vue&type=style&index=0&id=3dce685b&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dce685b"]])

export default __exports__